// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"9203fc52","455":"4f86dd3b","482":"5cec93a5","544":"3ff0ea80","708":"596707da","747":"16df36f1"}[chunkId] + ".chunk.js";
};